import React, { useEffect,useRef, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton, Container, Box, Typography, LinearProgress, InputAdornment, TextField } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CancelIcon from '@mui/icons-material/Cancel';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import CloseIcon from "@mui/icons-material/Close";
import apiClient from "../api/apiClient";
import { uD } from '../context/DC';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { THSarabun } from "./THSarabunNew"; 
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ClearIcon from '@mui/icons-material/Clear';
import Autocomplete from '@mui/material/Autocomplete';
import { styled } from '@mui/system';



const P08004 = () => {  
  const token = localStorage.getItem("token");
  const { mG } = uD();
  const [pg, sP] = useState(0); 
  const [ld, sL] = useState(true); 
  const [ac, sAc] = useState([]);
  const [ar, sAr] = useState([]);
  const [ap, sAp] = useState([]);
  const [sac, sSAc] = useState([]);
  const [d, sD] = useState([]);
  const [d2, sD2] = useState(null);
  const [d3, sD3] = useState(null);
  const [s, sS] = useState([]);

  const fD = async () => {
    sL(true);   
    sP(0); 
    try {         
      let r = await apiClient.get("/api-data/master-accshort", {headers: { "Authorization": `Bearer ${token}` ,},});
      if (r.data.s=='0' && r.data.d.rowCount > 0) {
        sAc(r.data.d.rows);
      } else {
        await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      } 
      // r = await apiClient.get("/api-data/master-ar", {headers: { "Authorization": `Bearer ${token}` ,},});
      // if (r.data.s=='0' && r.data.d.rowCount > 0) {
      //   sAr(r.data.d.rows);
      // } else {
      //   await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      // } 
      // r = await apiClient.get("/api-data/master-ap", {headers: { "Authorization": `Bearer ${token}` ,},});
      // if (r.data.s=='0' && r.data.d.rowCount > 0) {
      //   sAp(r.data.d.rows);
      // } else {
      //   await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      // }
    } catch (error) {
      let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
    }
    sL(false);
    sP(100);
  };

  useEffect(() => {
    fD();
  }, []);

  const fR = async () => {
      sL(true);
      sP(0);
      sD([]); 
      try {  
        const d = {
          screen: "08004",
          startcheckdate: dayjs(startCheckDate).format('YYYY-MM-DD'),
          endcheckdate: dayjs(endCheckDate).format('YYYY-MM-DD'),
          startdate: dayjs(startDate).format('YYYY-MM-DD'),
          enddate: dayjs(endDate).format('YYYY-MM-DD'),
          accounts: sac?.length ? sac.map(item => item.c2) : null
          };         
        const r = await apiClient.get("/api-data/banktransaction-getunknown", {headers: { Authorization: `Bearer ${token}` },params: d });
        if (r.data.s=='0' && r.data.d.rowCount > 0) {
          sD(r.data.d.rows);
          sS([]);
        } else if (r.data.s=='0' && r.data.d.rowCount == 0) {
          await mG({t: "Warning",tc: "#ffa000",m: "ไม่พบข้อมูล กรุณาค้นหาข้อมูลใหม่อีกครั้ง",bt: "OK",btc: "white",bc: "#ffb300",bch: "#ff6f00",}); 
        } else {
          await mG({t: "Failed",tc: "#e40000",m: r.data.m+r.data.e,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
        }      
      } catch (error) {
        let errMsg = "";
        if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
        } else if (error?.message) {errMsg = error.message;}
        await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      }
      sL(false);
      sP(100);
    };
  
  const handleExportExcel = async () => {
    if (!d.length) {
      alert("ไม่มีข้อมูลสำหรับ Export");
      return;
    }
  
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("FAP_UnknownStatement");

    worksheet.columns = [
      { header: "ลำดับ", key: "index", width: 10 },
      { header: "ธนาคาร", key: "tb_master_0801_c1", width: 15 },
      { header: "ประเภท", key: "tb_master_0801_c3", width: 15 },
      { header: "เลขที่บัญชี", key: "c1", width: 15 },

      { header: "วันที่เช็ค", key: "createdat", width: 15 },
      { header: "วันที่ธนาคาร", key: "d2", width: 15 },

// Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1      
      { header: "ประเภท", key: "cfg_c6", width: 12 },
// End Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1
      
      { header: "เงินนำฝากเข้าบัญชี", key: "d3", width: 15 },
      { header: "ชื่อลูกหนี้/ผู้โอนเงิน", key: "c4", width: 15 },
      { header: "ยอดคงเหลือ", key: "d7", width: 15 },
      { header: "เลขที่เช็ค", key: "c8", width: 15 },
      { header: "หมายเหตุ", key: "c9", width: 20 },

      { header: "สถานะ", key: "c10", width: 15 },
      { header: "หมายเหตุสถานะ", key: "c11", width: 25 },

      { header: "วันที่ข้อมูลธนาคารเข้า", key: "t15", width: 15 },   
      
      { header: "สกุลเงิน", key: "c43", width: 15 },
      { header: "เงินฝากต่างประเทศ", key: "d44", width: 15 },
     
    ];
  
    d.forEach((file, index) => {
      const row = worksheet.addRow({

        index: index + 1,
        tb_master_0801_c1: file.tb_master_0801_c1,
        tb_master_0801_c3: file.tb_master_0801_c3,
        c1: file.c1,
       
        createdat: file.createdat ? new Date(file.createdat).toISOString().split("T")[0] : "",
        d2: file.d2 ? new Date(file.d2).toISOString().split("T")[0] : "",

// Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1
        cfg_c6: file.cfg_c6,
// End Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1        

        d3: new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.d3),
        c4: file.tb_master_0201_c1 ? file.tb_master_0201_c1 : file.tb_master_0601_c1,
        d7: new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.d7),
        c8: file.c8,
        c9: file.c9,

        c10: file.tb_master_0901_c2, 
        c11: file.c11,

        t15: file.t15 ? new Date(file.t15).toISOString().split("T")[0] : "",

        c43: file.c43,
        d44: new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.d44),
       

      });
  
      // row.getCell(12).fill = {
      //   type: "pattern",
      //   pattern: "solid",
      //   fgColor: { argb: getColorByMatch(file.tb_master_0901_c2) },
      // };
    });
  
    // บันทึกเป็นไฟล์ Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, "FAP_UnknownStatement_Report.xlsx");
  };

  const getColorByMatch = (match) => {
// Add 202609101212 from 02_Enh_QT-2026-000014 item 1.1    
    if (["กระทบยอดเจอ SAP", "กระทบยอดเจอ BillPay"].some(text => match?.includes(text))) return "09D146"; // สีเขียว
    // if (match?.includes("กระทบยอดเจอ SAP")) return "09D146"; // สีเขียว
// End Add 202609101212 from 02_Enh_QT-2026-000014 item 1.1 
    if (match?.includes("กระทบยอดเจอ รอยืนยัน")) return "007EF6"; // สีฟ้า
    if (match?.includes("ระบบเจอ AR/AP")) return "FEDA00"; // สีเหลือง
    if (match?.includes("ปิดข้อมูลรายการนี้")) return "fe5b00"; // สีส้ม
    // return "E65151"; // สีแดง
  };
  
  // const fetchReportData = async () => {
  //   try {  

        // setAccountError(false);
        // setError(false);

        // setLoading(true);
        // setProgress(0);
        // setDataTtb([]); 

        //Get banktransaction
        // const dataToSend = {
        //   // screen: "Report05",
        //   startcheckdate: dayjs(startCheckDate).format('YYYY-MM-DD'),
        //   endcheckdate: dayjs(endCheckDate).format('YYYY-MM-DD'),
        //   startdate: dayjs(startDate).format('YYYY-MM-DD'),
        //   enddate: dayjs(endDate).format('YYYY-MM-DD'),
        //   accounts: selectedAccounts?.length ? selectedAccounts.map(item => item.account) : null,
        //   status: selectedStatus?.length ? selectedStatus.map(item => item.id) : null,
        //   ars: selectedArs?.length ? selectedArs.map(item => item.id) : null,
        //   aps: selectedAps?.length ? selectedAps.map(item => item.id) : null
        // };

        // const response = await apiClient.get("/api-data/reconcile-get", {
        //   headers: { Authorization: `Bearer ${token}` },
        //   params: dataToSend  // ส่งข้อมูลเป็น query params
        // });


        // const response = await apiClient.get("/api-data/banktransaction-verify", {
        //     params: { screen: "Report03" },
        //     headers: { "Authorization": `Bearer ${token}` }
        // });


        // if (response.data.banktransaction && response.data.banktransaction.rowCount > 0) {
        //     const rows = response.data.banktransaction.rows.map((row, idx) => ({
        //       ...row,
        //       txnId: `${idx}_${row.c1}`,
        //     }));
        //     setDataTtb(rows);

             

        // } else {
        //     openDialogWithMessage("ไม่พบข้อมูล กรุณาค้นหาข้อมูลใหม่อีกครั้ง", "Warning", "#ffa000", "OK", "white", "#ffb300", "#ff6f00");
        //     // console.error("No bank transaction data found");
        // }


  //       setLoading(false); // Data loaded, hide progress bar
  //       setProgress(100); // Set progress to 100%

  //   } catch (error) {
  //     console.error("Failed to fetch file list", error);
  //     setLoading(false); // Hide loading in case of error
  //   }
  // };


  // const fetchBankData = async () => {
  //     try {      
        // setLoading(true);
        // setProgress(0); // Reset progress when fetching starts
        // //Get Bank Acc
        // const response = await apiClient.get("/api-data/master-accshort", {
        //   headers: {
        //     'x-screen': 'fillbankstatement',  
        //     "Authorization": `Bearer ${token}` ,
        //   },
        // });

        // if (response.data.bankAccount) {
        //   const files = response.data.bankAccount;
        //   const filesTable = files.map(file => ({
        //     bankname: file.bankname,
        //     account: file.account,
        //     type: file.type
        //   }));
  
        //   // setAccountValue(filesTable);
        // }

        //Get AR
        // const responsear = await apiClient.get("/api-data/master-ar", {
        //     params: { screen: "Report03" },
        //     headers: { "Authorization": `Bearer ${token}` }
        // });

        // if (responsear.data.masterAccount) {
        //   const files = responsear.data.masterAccount;
        //   const filesTable = files.map(file => ({
        //     name: file.name,
        //     id: file.id
        //   }));

        //   setArValue(filesTable);
        // } else {
        //     console.error("No AR data found");
        // }

        //Get AP
        // const responseap = await apiClient.get("/api-data/master-ap", {
        //     params: { screen: "Report03" },
        //     headers: { "Authorization": `Bearer ${token}` }
        // });
        // if (responseap.data.masterAccount) {
        //   const files = responseap.data.masterAccount;
        //   const filesTable = files.map(file => ({
        //     name: file.name,
        //     id: file.id
        //   }));

        //   setApValue(filesTable);
        // } else {
        //     console.error("No AR data found");
        // }

        //Get Status
              // const responsest = await apiClient.get("/api-data/master-status", {
              //     params: { screen: "Report03" },
              //     headers: { "Authorization": `Bearer ${token}` }
              // });
              // if (responsest.data.master) {
              //   const files = responsest.data.master;
              //   const filesTable = files.map(file => ({
              //     name: file.name,
              //     id: file.id
              //   }));

              //   setStatusValue(filesTable);
              // } else {
              //     console.error("No Status data found");
              // }


    //     setLoading(false); // Data loaded, hide progress bar
    //     setProgress(100); // Set progress to 100%
  
    //   } catch (error) {
    //     console.error("Failed to fetch file list", error);
    //     setLoading(false); // Hide loading in case of error
    //   }
    // };

  const [dataTtb, setDataTtb] = useState([]);
  
  
  const [, forceUpdate] = useState(0);

  const [openDialog, setOpenDialog] = useState(false); // การแสดง Dialog
  const [dialogMessage, setDialogMessage] = useState(""); // ข้อความที่จะแสดงใน Dialog
  const [dialogTitle, setDialogTitle] = useState("Information"); // ค่าเริ่มต้นเป็น Error
  const [dialogTitleColor, setDialogTitleColor] = useState("black"); 
  const [dialogButtonText, setDialogButtonText] = useState("Close"); // ข้อความปุ่มเริ่มต้นเป็น Close
  const [dialogButtonTextColor, setDialogButtonTextColor] = useState("black"); 
  const [dialogButtonColor, setDialogButtonColor] = useState("white"); 
  const [dialogButtonColorh, setDialogButtonColorh] = useState("white"); 
  const fileInputRef = useRef(null);

  const [progress, setProgress] = useState(0); // To track the loading progress
  const [loading, setLoading] = useState(true); // To show loading spinner

  // const [files, setFiles] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startCheckDate, setStartCheckDate] = useState(null);
  const [endCheckDate, setEndCheckDate] = useState(null);
  // const [accountValue, setAccountValue] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [arValue, setArValue] = useState([]);
  const [selectedArs, setSelectedArs] = useState([]);
  const [apValue, setApValue] = useState([]);
  const [selectedAps, setSelectedAps] = useState([]);
  const [statusValue, setStatusValue] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const inputRefs = useRef({}); 
  const [error, setError] = useState(false);
  const [accountError, setAccountError] = useState(false);


  const handleChange = (id, field, value) => {
    if (!inputRefs.current[id]) {
      inputRefs.current[id] = {};
    }
    inputRefs.current[id][field] = value;
    // trigger render ใหม่แค่บางจุด
    forceUpdate((n) => n + 1);
  };

// Save ทั้งหมดพร้อม update state
  const handleSave = async () => {
    const updatedData = d.map((row) => {
      const updated = inputRefs.current[row.txnId] || {};
      return {
        ...row,
        c4: 'c4' in updated ? updated.c4 : row.c4,
        c6: 'c6' in updated ? updated.c6 : row.c6,        
        c10: 'c10' in updated ? (updated.c10 ?? null) : row.c10,
        c11: 'c11' in updated ? (updated.c11 ?? null) : row.c11,
      };
    });

    // console.log("ข้อมูลที่บันทึก:", updatedData);
    setDataTtb(updatedData);

    const dataToSend = {
      screen: "Report04",       
      data: updatedData     
    };

    // console.log(JSON.stringify(dataToSend).length);

    try {
      const response = await apiClient.post("/api-data/banktransaction-saveunknown", dataToSend, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.status === 200) {
        if (response.data.status === 'INSERT_SUCCESSFUL') {
          openDialogWithMessage(response.data.message, "Save Complete", "#519a39", "OK", "white", "#66bb49", "#3f762c");
          setDataTtb([]); // ล้าง rows
          inputRefs.current = {}; // ล้างข้อมูลที่ user เคยกรอกไว้
        } else {
          openDialogWithMessage("Unexpected result", "Warning", "#ffa000", "OK", "white", "#ffb300", "#ff6f00");
        }
      }
      
    } catch (error) {
      console.error("API Error:", error);
      openDialogWithMessage(error.response?.data?.error || "Failed to save data.", "Save Failed", "#e40000", "Close", "white", "#ff1616", "#d40000");
    }
  };

  // EditableCell Component ภายในไฟล์นี้เลย
  function EditableCell({ value, onSave }) {
    const [inputValue, setInputValue] = React.useState(value);

    React.useEffect(() => {
      setInputValue(value);
    }, [value]);

    const handleChange = (e) => {
      setInputValue(e.target.value);
    };

    const handleBlur = () => {
      onSave(inputValue);
    };

    return (
      <TextField
        variant="standard"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        fullWidth
        size="small"
      />
    );
  }


  // EditableAutocomplete Component (memoized)
const EditableAutocomplete = React.memo(({ value, options, onSave }) => {
    const [inputValue, setInputValue] = React.useState("");
    const [selectedOption, setSelectedOption] = React.useState(null);

    React.useEffect(() => {
      const found = options.find((opt) => opt.id === value);
      setSelectedOption(found || null);
      setInputValue(found ? `${found.id} - ${found.name}` : "");
    }, [value, options]);

    return (
      <Autocomplete
        options={options}
        getOptionLabel={(option) => `${option.id} - ${option.name}`}
        value={selectedOption}
        inputValue={inputValue}
        onChange={(event, newValue) => {
          setSelectedOption(newValue);
          onSave(newValue ? newValue.id : "");
        }}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === "input") setInputValue(newInputValue);
        }}
        renderInput={(params) => <TextField {...params} variant="standard" size="small" />}
        freeSolo={false}
        disableClearable
        isOptionEqualToValue={(option, val) => option.id === val.id}
      />
    );
  });








 

  // ฟังก์ชันกำหนดข้อความของสถานะ
const getStatusLabel = (match) => {
    if (match?.includes("Y_")) return "Match";
    if (match?.includes("C_")) return "Confirm";
    if (match?.includes("D_")) return "Check";
    return "Not Match";
  };
  
  // ฟังก์ชันกำหนดสีของ cell

  

  const openDialogWithMessage = (message, title = "Information", titleColor = "black", buttonText = "Close", buttonTextColor = "black", buttonColor = "white", buttonColorh = "white") => {
    setDialogMessage(message);
    setDialogTitle(title);
    setDialogTitleColor(titleColor);
    setDialogButtonText(buttonText);
    setDialogButtonTextColor(buttonTextColor);
    setDialogButtonColor(buttonColor);
    setDialogButtonColorh(buttonColorh);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Container component="main" maxWidth="96%" sx={{marginTop: "40px",border: "0px solid #e0e0e0",boxSizing: "border-box",}}>

      {/* Loading Progress Bar */}
      {ld ? (
        <Box sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          zIndex: 999,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}>
          <LinearProgress variant="determinate" value={pg} sx={{ width: '50%' }} />
        </Box>

       ) : ( 

      <Box sx={{ width: '100%',display: "flex",flexDirection: "column", marginLeft:0, marginBottom:0, boxShadow: "none",marginTop: "0px",border: "0px solid #e0e0e0" ,boxSizing: "border-box",
        backgroundColor: "background.paper",
      }}>

        <Box sx={{ borderRadius: 0,boxSizing: "border-box",marginBottom:"4px", boxShadow: "none",marginTop: "0px",
          textAlign: "center",
          verticalAlign: "middle",
          padding:1,
          backgroundColor: "#f5f5f5",
          fontSize: "calc(14px + 0.5vw)",
          fontWeight: "bold",
          color: "#333",
          width: '100%'
        }}>
          รายงานรายการเดินบัญชีจากธนาคารสำหรับเงินไม่ทราบแหล่งที่มา
        </Box>

        <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
                        borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
                        display: "flex",            // ✅ เพิ่ม
                        justifyContent: "center",   // ✅ จัดให้อยู่ตรงกลางแนวนอน
                        alignItems: "center",
                        gap: 2, flexWrap: "wrap",
                      }}>

              <Autocomplete
                  multiple
                  options={ac}
                  getOptionLabel={(option) =>
                    `${option.c11} - ${option.c2} (${option.c12})`
                  }
                  value={sac}
                  // onChange={(event, newValue) => setSelectedAccounts(newValue)}
                  onChange={(event, newValue) => {
                    sSAc(newValue);
                    setAccountError(false);  // ล้าง error เมื่อเปลี่ยนค่า
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="เลือกบัญชีธนาคาร" placeholder="เลือกได้หลายบัญชี" style={{ width: 300}} size="small" id="account" 
                      error={accountError}
                      helperText={accountError ? "กรุณาเลือกอย่างน้อย 1 บัญชี" : ""}
                      // sx={{
                      //     fontSize: 11,
                      //     '& .MuiChip-label': {
                      //       fontSize: 10,
                      //     },
                      //   }}
                    />
                  )}
                  PaperComponent={(props) => (
                    <Paper
                      {...props}
                      // sx={{
                      //   fontSize: 11,
                      //   '& .MuiAutocomplete-listbox': {
                      //     fontSize: 11,
                      //     padding: 0,
                      //   },
                      //   '& .MuiAutocomplete-option': {
                      //     fontSize: 11,
                      //     paddingTop: 4,
                      //     paddingBottom: 4,
                      //   },
                      // }}
                    />
                  )}
                />


              <LocalizationProvider dateAdapter={AdapterDayjs}>

                  <DatePicker label="เลือกวันที่เช็คเริ่มต้น"
                              value={startCheckDate}
                              onChange={(newValue) => {
                                setStartCheckDate(newValue);
                                setError(false);
                                // ถ้าเปลี่ยน startDate ใหม่ และ endDate น้อยกว่า startDate ให้ reset endDate
                                if (endCheckDate && newValue && endCheckDate < newValue) {
                                  setEndCheckDate(null);
                                }
                              }}
                              // onChange={(newValue) => setStartDate(newValue)}
                              sx={{ width: 190 }}
                              slotProps={{
                                field: { clearable: true, onClear: () => setStartCheckDate(null) },
                                textField: { 
                                  size: 'small',
                                  placeholder: 'Select Date',
                                  error: error,
                                  helperText: error && !startDate ? 'กรุณาเลือกวัน' : '',
                                },
                              }}
                              
                            />

                  <DatePicker label="เลือกวันที่เช็คสิ้นสุด"
                              value={endCheckDate}
                              onChange={(newValue) => setEndCheckDate(newValue)}
                              disabled={!startCheckDate}  // <-- ถ้า startDate ยังไม่เลือก disable ไว้
                              minDate={startCheckDate}     // <-- กำหนดวันที่น้อยสุดของ endDate เป็น startDate
                              sx={{ width: 190 }}
                              slotProps={{
                                field: { clearable: true, onClear: () => setEndCheckDate(null) },
                                textField: { size: 'small',placeholder: 'Select End Date'},
                              }}
                              
                            />

                  
                {/* </Box> */}
              </LocalizationProvider>

               
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker label="เลือกวันที่เริ่มต้น"
                              value={startDate}
                              onChange={(newValue) => {
                                setStartDate(newValue);
                                setError(false);
                                // ถ้าเปลี่ยน startDate ใหม่ และ endDate น้อยกว่า startDate ให้ reset endDate
                                if (endDate && newValue && endDate < newValue) {
                                  setEndDate(null);
                                }
                              }}
                              // onChange={(newValue) => setStartDate(newValue)}
                              sx={{ width: 190 }}
                              slotProps={{
                                field: { clearable: true, onClear: () => setStartDate(null) },
                                textField: { 
                                  size: 'small',
                                  placeholder: 'Select Date',
                                  error: error,
                                  helperText: error && !startDate ? 'กรุณาเลือกวัน' : '',
                                },
                              }}
                              
                            />

                  <DatePicker label="เลือกวันที่สิ้นสุด"
                              value={endDate}
                              onChange={(newValue) => setEndDate(newValue)}
                              disabled={!startDate}  // <-- ถ้า startDate ยังไม่เลือก disable ไว้
                              minDate={startDate}     // <-- กำหนดวันที่น้อยสุดของ endDate เป็น startDate
                              sx={{ width: 190 }}
                              slotProps={{
                                field: { clearable: true, onClear: () => setEndDate(null) },
                                textField: { size: 'small',placeholder: 'Select End Date'},
                              }}
                              
                            />

                  
                {/* </Box> */}
              </LocalizationProvider>



                {/* <Autocomplete
                  multiple
                  options={ar}
                  getOptionLabel={(option) =>
                    `${option.c1} (${option.c2})`
                  }
                  value={selectedArs}
                  onChange={(event, newValue) => setSelectedArs(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} label="เลือกลูกหนี้" placeholder="เลือกได้หลายบัญชี" style={{ width: 250}} size="small" id="ar" 
                      sx={{
                          fontSize: 11,
                          '& .MuiChip-label': {
                            fontSize: 10,
                          },
                        }}
                    />
                  )}
                  PaperComponent={(props) => (
                    <Paper
                      {...props}
                      sx={{
                        fontSize: 11,
                        '& .MuiAutocomplete-listbox': {
                          fontSize: 11,
                          padding: 0,
                        },
                        '& .MuiAutocomplete-option': {
                          fontSize: 11,
                          paddingTop: 4,
                          paddingBottom: 4,
                        },
                      }}
                    />
                  )}
                />


                <Autocomplete
                  multiple
                  options={ap}
                  getOptionLabel={(option) =>
                    `${option.c1} (${option.c2})`
                  }
                  value={selectedAps}
                  onChange={(event, newValue) => setSelectedAps(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} label="เลือกเจ้าหนี้" placeholder="เลือกได้หลายบัญชี" style={{ width: 250}} size="small" id="ap" 
                      sx={{
                          fontSize: 11,
                          '& .MuiChip-label': {
                            fontSize: 10,
                          },
                        }}
                    />
                  )}
                  PaperComponent={(props) => (
                    <Paper
                      {...props}
                      sx={{
                        fontSize: 11,
                        '& .MuiAutocomplete-listbox': {
                          fontSize: 11,
                          padding: 0,
                        },
                        '& .MuiAutocomplete-option': {
                          fontSize: 11,
                          paddingTop: 4,
                          paddingBottom: 4,
                        },
                      }}
                    />
                  )}
                /> */}



            

                <button
                  onClick={fR}
                  style={{
                    padding: "8px 15px",
                    background: "#0061d4",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "calc(8px + 0.5vw)",
                    marginRight: "10px",
                  }}
                >
                  แสดงข้อมูล
              </button>
  

          </Box>

        {d.length <= 0 && (
        <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "0px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
          borderRadius: 0,textAlign: "center",verticalAlign: "middle",fontSize: "calc(14px - 0.01vw)",padding:1,
        }}>
              "กรุณาคลิกแสดงข้อมูลรายการเดินบัญชีจากธนาคารสำหรับเงินไม่ทราบแหล่งที่มา"
        </Box>
        )}
        
        {d.length > 0 && (

          <>

          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 400,
              overflow: "auto", // ให้ scroll แนวตั้ง
              minWidth: 800,     // บังคับให้มี scroll แนวนอนถ้าเนื้อหากว้าง
            }}
          >
            <Table size="small" aria-label="a dense table" sx={{ borderCollapse: 'collapse' }}>
            <TableHead sx={{ backgroundColor: '#f5f5f5',whiteSpace: "nowrap", }}>
                <TableRow>

                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)'}}>#</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ธนาคาร</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ประเภท</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เลขที่บัญชี</TableCell>

                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>วันที่เช็ค</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>วันที่ธนาคาร</TableCell>

{/* Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1  */}
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ประเภท</TableCell>
{/* End Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1  */}

                  {/* <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>วันที่ SAP</TableCell> */}

                  {/* <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ชุดเอกสาร</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เลขที่เอกสาร</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เลขที่รายการ</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>หมายเหตุ SAP</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>บัญชีหักกลบ</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ชื่อบัญชีหักกลบ</TableCell> */}

                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เงินนำฝากเข้าบัญชี</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ชื่อลูกหนี้/ผู้โอนเงิน</TableCell>
                  {/* <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เงินหักบัญชี</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ชื่อเจ้าหนี้/ผู้รับเงิน</TableCell> */}
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>ยอดคงเหลือ</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เลขที่เช็ค</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>หมายเหตุ</TableCell>
                  
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>สถานะ</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>หมายเหตุสถานะ</TableCell>

                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>วันที่ข้อมูลธนาคารเข้า</TableCell>
                  {/* <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>วันที่ข้อมูล SAP เข้า</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>วันที่รันกระทบยอด</TableCell> */}
                  
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>สกุลเงิน</TableCell>
                  <TableCell align="center" sx={{ position: "sticky", top: 0, backgroundColor: "#f5f5f5", zIndex: 1, border: '1px solid rgba(0, 0, 0, 0.3)' }}>เงินฝากต่างประเทศ</TableCell>


                </TableRow>
              </TableHead>


              <TableBody>
                {d.map((file, index) => (
                  <TableRow
                    key={index+1}
                    // sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.3)' }}
                    // sx={{ '&:last-child td, &:last-child th': { border: 0 ,whiteSpace: "nowrap", borderBottom: '1px solid rgba(0, 0, 0, 0.3)'} }}
                  >


                    <TableCell align="center" component="th" scope="row" sx={{ border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {index+1}
                    </TableCell>

                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.tb_master_0801_c1}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.tb_master_0801_c3}</TableCell>

                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.c1}</TableCell>
                     

                    <TableCell align="center" sx={{ whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                    {file.createdat ? new Date(file.createdat).toISOString().split("T")[0] : ""}
                  </TableCell>
                  <TableCell align="center" sx={{ whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                    {file.d2 ? new Date(file.d2).toISOString().split("T")[0] : ""}
                  </TableCell>

{/* Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1  */}
                  <TableCell align="center" sx={{ whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                    {file.cfg_c6}
                  </TableCell>
{/* End Add 202609071623 from 02_Enh_QT-2026-000014 item 1.1  */}
                  
                  {/* <TableCell align="center" sx={{ whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                    {file.d18 ? new Date(file.d18).toISOString().split("T")[0] : ""}
                  </TableCell> */}

                    {/* <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.c19}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.c20}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.c21}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.c22}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.c23}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.c24}</TableCell> */}

                    <TableCell align="right" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                      {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.d3)}
                    </TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >
                      {file.tb_master_0201_c1 ? file.tb_master_0201_c1 : file.tb_master_0601_c1}
                      </TableCell>
                    {/* <TableCell align="right" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                        {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.d5)}
                    </TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >
                      {file.tb_master_0301_c1 ? file.tb_master_0301_c1 : file.tb_master_0701_c1}
                      </TableCell> */}
                    <TableCell align="right" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                        {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.d7)}
                    </TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>{file.c8}</TableCell>
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)'}}>{file.c9}</TableCell>

                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.tb_master_0901_c2}</TableCell>  
                    <TableCell align="left" sx={{whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)'}}>{file.c11}</TableCell>

                    <TableCell align="center" sx={{ whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                    {file.t15 ? new Date(file.t15).toISOString().split("T")[0] : ""}
                  </TableCell>
                  {/* <TableCell align="center" sx={{ whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                    {file.t30 ? new Date(file.t30).toISOString().split("T")[0] : ""}
                  </TableCell>
                  <TableCell align="center" sx={{ whiteSpace: "nowrap", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                    {file.recdat ? new Date(file.recdat).toISOString().split("T")[0] : ""}
                  </TableCell> */}

                  <TableCell align="left" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }} >{file.c43}</TableCell>
                  <TableCell align="right" sx={{whiteSpace: "pre", border: '1px solid rgba(0, 0, 0, 0.3)' }}>
                    {new Intl.NumberFormat('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(file.d44)}
                  </TableCell>

                  </TableRow>
                ))}
              </TableBody>


            </Table>
          </TableContainer>

          </>
        )}
        
        {d.length > 0 && (
          <Box sx={{  marginBottom:0, boxShadow: "none",marginTop: "4px" ,boxSizing: "border-box",
            borderRadius: 0,
            padding: "4px 4px",
            textAlign: "center",
            verticalAlign: "middle",
          }}>
            {/* <button
              onClick={handleExportPDF}
              style={{
                padding: "8px 15px",
                background: "#0061d4",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "calc(8px + 0.5vw)",
                marginRight: "10px",
              }}
              // disabled={selectedFiles.length === 0}
            >
              Export PDF
            </button> */}

            <button
              onClick={handleExportExcel}
              style={{
                padding: "8px 15px",
                background: "#0061d4",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "calc(8px + 0.5vw)",
              }}
            >
              Export Excel
            </button>
          </Box>
        )}

      </Box>

      )}


      <Dialog open={openDialog} onClose={handleCloseDialog} sx={{maxWidth: "auto",  width: "auto", margin: "auto",overflow: "visible", }}>
          <DialogTitle sx={{color: dialogTitleColor,fontSize: "1.3rem",fontWeight: "400",textAlign: "left",padding: "5px",minHeight: "30px",whiteSpace: "pre-wrap",paddingRight: "40px", }}>
          {dialogTitle} 
          </DialogTitle>
          <IconButton sx={{position: "absolute",right: "5px",top: "3px",borderRadius: "8px", }} onClick={handleCloseDialog}> 
              <CloseIcon /> 
          </IconButton>
          <DialogContent sx={{ fontSize: "1rem",maxHeight: "100%", overflowY: "auto", paddingBottom: "0",whiteSpace: "pre-wrap",wordBreak: "break-word",textAlign: "center", }}>
          {dialogMessage}
          </DialogContent>
          <DialogActions sx={{display: "flex", justifyContent: "center", alignItems: "center",marginTop: "20px",}}>
          <Button variant="contained" sx={{ backgroundColor: dialogButtonColor, color: dialogButtonTextColor, "&:hover": { backgroundColor: dialogButtonColorh } }} onClick={handleCloseDialog}>
              {dialogButtonText}
          </Button>
          </DialogActions>
      </Dialog>

    </Container>
  );
};




export default P08004;